import { createRelayResource } from '@townsquare/relay-utils';
import { AggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type { ResourceContext } from '@townsquare/router/types';

import useProductActivationCheckQuery, {
	useProductActivationCheckQuery as QueryType,
} from './__generated__/useProductActivationCheckQuery.graphql';

export const productActivationResource = createRelayResource<QueryType>({
	getQuery: (_, resourceStoreContext) => {
		const context = resourceStoreContext as ResourceContext;
		return {
			query: useProductActivationCheckQuery,
			variables: {
				cloudIds: context.collabContext?.rovoWorkspace ? [context.collabContext.rovoWorkspace] : [],
			},
			environment: AggRelayEnvironment,
		};
	},
	maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
